<template><section><h1>CheckBox 多选</h1>
<p>一组备选项中进行多选</p>

<h3>基础用法</h3>
<p>单独使用可以表示两种状态之间的切换，写在标签中的内容为 checkbox 按钮后的介绍。</p>
<demo-block>
                <div class="source" slot="source"><ayu-checkbox v-model="checked">选择</ayu-checkbox>

</div>
                <p><code>ayu-checkbox</code>元素中定义v-model绑定变量，单一的<code>checkbox</code>中，默认绑定变量的值会是<code>Boolean</code>，选中为<code>true</code>。</p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-checkbox</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"checked"</span>&gt;</span>选择<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-checkbox</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">checked</span>: <span class="hljs-literal">true</span>,
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>禁用状态</h3>
<demo-block>
                <div class="source" slot="source"><ayu-checkbox v-model="checked1" disabled>选择</ayu-checkbox>
<ayu-checkbox v-model="checked2" disabled>选择</ayu-checkbox>


</div>
                <p>设置<code>disabled</code>属性即可。</p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-checkbox</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"checked1"</span> <span class="hljs-attr">disabled</span>&gt;</span>选择<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-checkbox</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ayu-checkbox</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"checked2"</span> <span class="hljs-attr">disabled</span>&gt;</span>选择<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-checkbox</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">checked1</span>: <span class="hljs-literal">false</span>,
      <span class="hljs-attr">checked2</span>: <span class="hljs-literal">true</span>,
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3>多选框组</h3>
<p>适用于多个勾选框绑定到同一个数组的情景，通过是否勾选来表示这一组选项中选中的项。</p>
<demo-block>
                <div class="source" slot="source"><ayu-checkbox-group v-model="checkbox2">
  <ayu-checkbox :label="1">选项一</ayu-checkbox>
  <ayu-checkbox :label="2">选项二</ayu-checkbox>
  <ayu-checkbox :label="3">选项三</ayu-checkbox>
  <ayu-checkbox :label="4">选项四</ayu-checkbox>
</ayu-checkbox-group>


</div>
                <p><code>checkbox-group</code>元素能把多个 <code>checkbox</code> 管理为一组，只需要在 Group 中使用v-model绑定<code>Array</code>类型的变量即可。 <code>ayu-checkbox</code> 的 <code>label</code>属性是该 checkbox 对应的值。</p>

                <div class="highlight" slot="highlight"><pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ayu-checkbox-group</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"checkbox2"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">ayu-checkbox</span> <span class="hljs-attr">:label</span>=<span class="hljs-string">"1"</span>&gt;</span>选项一<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-checkbox</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">ayu-checkbox</span> <span class="hljs-attr">:label</span>=<span class="hljs-string">"2"</span>&gt;</span>选项二<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-checkbox</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">ayu-checkbox</span> <span class="hljs-attr">:label</span>=<span class="hljs-string">"3"</span>&gt;</span>选项三<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-checkbox</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">ayu-checkbox</span> <span class="hljs-attr">:label</span>=<span class="hljs-string">"4"</span>&gt;</span>选项四<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-checkbox</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ayu-checkbox-group</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">checkbox2</span>: [<span class="hljs-number">2</span>],
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</div></demo-block>
<h3>Checkbox Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">value / v-model</td>
<td style="text-align:left">绑定值</td>
<td style="text-align:left">string / number / boolean</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">label</td>
<td style="text-align:left">选中状态的值（只有在checkbox-group时有效）</td>
<td style="text-align:left">string / number / boolean</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">disabled</td>
<td style="text-align:left">是否禁用</td>
<td style="text-align:left">Boolean</td>
<td style="text-align:left">true/false</td>
<td style="text-align:left">false</td>
</tr>
<tr>
<td style="text-align:left">name</td>
<td style="text-align:left">原生 name 属性</td>
<td style="text-align:left">string</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
</tbody>
</table>
<h3>Checkbox-group Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">value / v-model</td>
<td style="text-align:left">绑定值</td>
<td style="text-align:left">string / number / boolean</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">disabled</td>
<td style="text-align:left">是否禁用</td>
<td style="text-align:left">Boolean</td>
<td style="text-align:left">true/false</td>
<td style="text-align:left">false</td>
</tr>
</tbody>
</table>
<h3>Checkbox-group Events</h3>
<table>
<thead>
<tr>
<th style="text-align:left">事件名称</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">回调函数</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">change</td>
<td style="text-align:left">绑定值变化时触发的事件</td>
<td style="text-align:left">更新后的值</td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default {
  data() {
    return {
      checked: true,
      checked1: false,
      checked2: true,
      checkbox2: [2],
      check4: []
    }
  }
}
</script>